import React from 'react';
import { Link as ChakraLink, LinkProps } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { NavLinkProps } from '../types';

/**
 * NavLink component for consistent styling of navigation links
 */
const NavLink: React.FC<NavLinkProps> = ({ children, path, isExternal, isMobile }) => {
  const linkStyles = {
    px: { base: 1.5, md: 2 },
    py: isMobile ? 0.5 : { base: 0.5, md: 1 },
    rounded: "md",
    _hover: {
      textDecoration: 'none',
      color: 'brand.primary.base',
    },
    fontWeight: "medium",
    fontSize: isMobile ? "sm" : "inherit"
  };

  // For external links or anchor links (those starting with #)
  if (isExternal || (path && path.startsWith('#'))) {
    return (
      <ChakraLink
        {...linkStyles}
        href={isExternal ? path : (path.startsWith('#') ? path : `#${path}`)}
        isExternal={isExternal || false}
      >
        {children}
      </ChakraLink>
    );
  }

  // For internal route links (those starting with /)
  if (path && path.startsWith('/')) {
    return (
      <RouterLink to={path} style={{ textDecoration: 'none' }}>
        <ChakraLink
          {...linkStyles}
          as="span" // Use span to prevent nested <a> tags
        >
          {children}
        </ChakraLink>
      </RouterLink>
    );
  }

  // For anchor links (section links on the same page)
  return (
    <ChakraLink
      {...linkStyles}
      href={`#${path}`}
    >
      {children}
    </ChakraLink>
  );
};

export default NavLink;